import DocAiExtractorsTable from 'views/docai/Extractors/ExtractorsTable';

const DocAiExtractors = () => <DocAiExtractorsTable />;

export default DocAiExtractors;
